import { RelayEnvironmentProvider, useRelayEnvironment } from "react-relay";

import { CardEntryErrorBanner } from "@/features/Square/CardEntryErrorBanner";
import { WithRealSafeAreaInsets } from "@/hooks/useRealSafeAreaInsets";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { PaymentMethodsModalQueryWrapper } from "./components/PaymentMethodsModalQueryWrapper";

type PaymentMethodsModalProps = {
  isOpen: boolean;
  errorMessage?: string;
  setIsOpen: (isOpen: boolean) => void;
  setIsAddACardModalOpen: (isOpen: boolean) => void;
};

export const PaymentMethodsModal = ({
  isOpen,
  errorMessage,
  setIsOpen,
  setIsAddACardModalOpen,
}: PaymentMethodsModalProps) => {
  const environment = useRelayEnvironment();

  return (
    <WithRealSafeAreaInsets>
      <StandardModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        disableContentScroll={true}
        content={
          <RelayEnvironmentProvider environment={environment}>
            <Box flex={1}>
              <Box px={6}>
                <CardEntryErrorBanner message={errorMessage} />
              </Box>
              <PaymentMethodsModalQueryWrapper
                setIsAddACardModalOpen={setIsAddACardModalOpen}
                setIsPaymentMethodsModalOpen={setIsOpen}
              />
            </Box>
          </RelayEnvironmentProvider>
        }
      />
    </WithRealSafeAreaInsets>
  );
};
